import {Component, OnInit, inject, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {SalesService} from '../../services/sales.service';
import {MarketingDataRequest} from '../../models/marketingData.request';
import {EventsManager} from '../../events/events.manager';
import {PlanViewTypeEnum} from '../../enums/plan-view-type.enum';
import {resolveXrayExamStatement} from '../../utils/xray-exam-statement.util';

@Component({
  selector: 'app-fee-schedule',
  templateUrl: './fee-schedule.component.html',
  styleUrls: ['./fee-schedule.component.scss'],
  standalone: false
})

export class FeeScheduleComponent implements OnInit {
  private _eventsManager: EventsManager = inject(EventsManager);
  private _salesService: SalesService = inject(SalesService);
  private _destroyRef: DestroyRef = inject(DestroyRef);

  public readonly PlanViewType: typeof PlanViewTypeEnum = PlanViewTypeEnum;
  public currentCovLevel: number = 0;
  private _feeScheduleInfo: any = {};
  public selectedPlan: any = {};
  public footer: string = 'X%';
  public details: any = {};
  public plans: any = {};

  public ngOnInit(): void {
    this.plans = this._eventsManager.getOfficeInfo();
    this._feeScheduleInfo = this._eventsManager.getFeeScheduleInfo();
    this.selectedPlan = this.plans.benefitPlanTemplates?.find((x: {benefitPlanTemplateId: any}) => x.benefitPlanTemplateId == this._feeScheduleInfo.templateId);
    this.getFeeSchedule(this.currentCovLevel);

    this._eventsManager.feeScheduleUpdate
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((result: any) => {
        this._feeScheduleInfo = result;
      });
  }

  public getXrayExamStatement(): string {
    return resolveXrayExamStatement(this.details?.salesPlanMarketingDetails?.commonDentalPlanSavings?.xrayExamFooterText);
  }

  public getFeeSchedule(level: number) {
    this.currentCovLevel = level;
    const params: MarketingDataRequest = {practice: this._feeScheduleInfo.practiceId, template: this._feeScheduleInfo.templateId, coverageLevelName: this.selectedPlan.coverageLevels[this.currentCovLevel].caption, pageName: this._feeScheduleInfo.pageName};
    this._salesService.getMarketingDetails(params)
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((result: any) => {
        this.details = result;
        this.details.salesPlanMarketingDetails?.default?.forEach((item: { itemName: string; value: { column1: string; }[]; }) => {
          if (item.itemName == 'Footer') {
            this.footer = item.value[0].column1;
          }
        });
      });
  }
}
